import areaTreeLevels from './AreaTreeLevels/selectors';
import areaTrees from './AreaTrees/selectors';
export default {
  areaTreeLevels: areaTreeLevels,
  areaTrees: areaTrees
};